

const EMPTY_TEXT = '';
const CREATIONDATE = 'creationDate';
const DESCENDING = 'desc';
export interface SuggestionListQuery {
  search?: string;
  status?: string;
  createdFrom?: string;
  createdTo?: string;
  sort?: 'creationDate' | 'status' | 'department' | 'initiator';
  direction?: 'asc' | 'desc';
}

export function defaultSuggestionListQuery(): SuggestionListQuery {
  return {search: EMPTY_TEXT, status: EMPTY_TEXT, createdFrom: EMPTY_TEXT, createdTo: EMPTY_TEXT, sort: CREATIONDATE, direction: DESCENDING};
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/suggestion-lists/models/suggestion-list-query.model.ts